import $ from 'jquery';
import { debounce } from 'lodash';
// --- Slider --- (Taken from slider.js)
// Resize slider
(function ($) {
    function sliderResizer(mySlider) {
        // How many slides are in a row?
        let childrenL = mySlider.find('.slider-list').children().length, slideCols = Math.floor(mySlider.outerWidth() / mySlider.find('.slide').outerWidth());
    }
    // $('.feature-slider-div').each(function(){
    //     let childrenL = $(this).find('.slider-list').children().length;
    //     $(this).find('.Feature-slider').addClass('slider-nav'+childrenL);
    // });
    // Initiate slider
    $('.testimonial-slider .slider').each(function () {
        // Create a paginator
        if ($(this).find('.testimonial-slider-paginator').length <= 0) {
            if ($(this).parents('.testimonial-slider').length) {
                if ($(this).find('.testimonial-slider-paginator').length > 1) {
                    $(this).append('<ul class="testimonial-slider-paginator hidden"></ul>');
                }
            }
            else {
                $(this).append('<ul class="testimonial-slider-paginator hidden"></ul>');
            }
        }
        let childrenL = $(this).find('.slider-list .slide').length, myPaginator = $(this).find('.testimonial-slider-paginator');
        if ($(this).parents('.testimonial-slider').length) {
            if (childrenL > 1) {
                for (var i = 1; i <= childrenL; ++i) {
                    $('<li/>').attr('data-slider', i).appendTo(myPaginator);
                }
            }
            else {
                $(this).find('.slider-nav').remove();
            }
        }
        else {
            for (var i = 1; i <= childrenL; ++i) {
                $('<li/>').attr('data-slider', i).appendTo(myPaginator);
            }
        }
        $(this).find('.testimonial-slider-paginator li:first-child').addClass('active');
        sliderResizer($(this));
    });
    // Click a paginator point
    $('.testimonial-slider-paginator li').on('click', function () {
        let myParent = $(this).parents('.slider'), pos = $(this).attr('data-slider');
        // Boxed slider
        if (myParent.hasClass('slider-boxed')) {
            // Count left margin
            let newleft = -myParent.find('.slide:nth-child(' + pos + ')').position().left
                - parseFloat(myParent.find('.slide:nth-child(' + pos + ')').css('margin-left'));
            // Sliders overflowing from the container are still justified to it:
            let containerReducer = $('.container').offset().left + parseFloat($('.container').css('padding-left'));
            if (myParent.parents('.section').hasClass('testimonial-slider') && $(window).width() < 768) {
                newleft += containerReducer;
            }
            // Animate list
            myParent.find('.slider-list').animate({ left: newleft }, 500);
            // Deactivate previous slide
            myParent.find('.testimonial-slider-paginator li').removeClass('active');
            myParent.find('.slide').removeClass('active');
            // Activate this slide and paginator point
            myParent.find('.testimonial-slider-paginator li[data-slider=' + pos + ']').addClass('active');
            myParent.find('.slide:nth-child(' + pos + ')').addClass('active');
            // Slide fader
        }
        else if (myParent.hasClass('slider-fader')) {
            let newSlide = myParent.find('.slide:nth-child(' + pos + ')');
            // Activate proper paginator point
            myParent.find('.testimonial-slider-paginator li').removeClass('active');
            myParent.find('.testimonial-slider-paginator li[data-slider=' + pos + ']').addClass('active');
            // Set new height for list
            setTimeout(function () {
                let newH = newSlide.outerHeight();
                myParent.find('.slider-list').animate({ height: newH }, 300);
            }, 100);
            // Activate current slide
            myParent.find('.slide.active').addClass('active-fading-out');
            setTimeout(function () {
                myParent.find('.slide.active').removeClass('active active-fading-out');
                newSlide.addClass('active-fading-in');
                setTimeout(function () {
                    newSlide.removeClass('active-fading-in').addClass('active');
                }, 150);
            }, 100);
        }
        // Deactivate loop
        if ($(this).prev().first().length <= 0) {
            myParent.find('.slider-prev').addClass('inactive');
        }
        else {
            myParent.find('.slider-prev').removeClass('inactive');
        }
        if ($(this).next().first().length <= 0) {
            myParent.find('.slider-next').addClass('inactive');
        }
        else {
            myParent.find('.slider-next').removeClass('inactive');
        }
    });
    // Click a prev/next button
    $('.testimonial-slider .slider .slider-prev').on('click', function () {
        let myParent = $(this).parents('.slider'), currentActive = myParent.find('.testimonial-slider-paginator li.active').first();
        if (currentActive.prev().length > 0) {
            currentActive.prev().first().click();
        }
        else {
            myParent.find('.testimonial-slider-paginator li:last-child').click();
        }
    });
    $('.testimonial-slider .slider .slider-next').on('click', function () {
        let myParent = $(this).parents('.slider'), currentActive = myParent.find('.testimonial-slider-paginator li.active').last();
        if (currentActive.next().length > 0) {
            currentActive.next().first().click();
        }
        else {
            myParent.find('.testimonial-slider-paginator li:first-child').click();
        }
    });
    // Swipe the slider
    $('.slider').swipe({
        allowPageScroll: 'vertical',
        preventDefaultEvents: false,
        swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
            if ($(window).width() <= 767) {
                let myParent = $(event.target).parents('.slider');
                myParent.find('.testimonial-slider-paginator').children().each(function () {
                    if ($(this).hasClass('active')) {
                        if (direction == 'left' && $(this).next().length > 0) {
                            $(this).next().first().click();
                            return false;
                        }
                        else if (direction == 'left' && $(this).next().length === 0) {
                            myParent.find('.testimonial-slider-paginator li').first().click();
                            return false;
                        }
                        else if (direction == 'right' && $(this).prev().length > 0) {
                            $(this).prev().first().click();
                            return false;
                        }
                        else if (direction == 'right' && $(this).prev().length === 0) {
                            myParent.find('.testimonial-slider-paginator li').last().click();
                            return false;
                        }
                    }
                });
            }
        },
        excludedElements: 'label, button, input, select, textarea, .noSwipe'
    });
    // Activate sliders on ready and re-activate sliders after resizing
    function sliderActivator(mySlider) {
        mySlider.find('.testimonial-slider-paginator li.active').click();
    }
    $(window).resize(debounce(function () {
        $('.testimonial-slider .slider:not(.slider-fader)').each(function () {
            sliderResizer($(this));
            sliderActivator($(this));
        });
        // Resize slider-fader
        $('.testimonial-slider .slider.slider-fader').each(function () {
            let newH = $(this).find('.slide.active').outerHeight();
            $(this).find('.slider-list').animate({ height: newH }, 100);
        });
    }, 100));
    $('.testimonial-slider .slider').each(function () {
        sliderActivator($(this));
    });
})(jQuery);
// End of Slider
// ---------------------------------------------------------------------------------------------------------------
// Taken from accessibility.js
/**
* ==================================================
* Sets the wrapper testimonial slider for accessibility
* ==================================================
*
* This file dynamically sets the tabIndex and focus by observing for mutations
*
* @Author Amal Ajith PM
*/
$(document).ready(function () {
    /**
    *
    * @type {NodeListOf<HTMLDivElement>}
    */
    const slideNodes = document.querySelectorAll('.testimonial-slider .slide');
    const slideNavButtons = document.querySelectorAll('.testimonial-slider .slider-nav button');
    /**
    * The mutation configuration
    * @type {{attributesFilter: string[], attributes: boolean}}
    */
    const classMutationConfig = { attributes: true, attributeFilter: ['class'] };
    /**
    *
    * @param {HTMLDivElement} slide
    * @param {Boolean} makeTabbable
    */
    const toggleStateOfTabbableItemsInSlide = (slide, makeTabbable) => {
        /**
        *
        * @type {NodeListOf<HTMLAnchorElement>}
        */
        const slideLinks = slide.querySelectorAll('a');
        slideLinks.forEach((linkItem) => {
            linkItem.tabIndex = makeTabbable ? '0' : '-1';
        });
    };
    /**
    * Callback function when a mutation happens.
    * We are looking for class mutation of active.
    * @param mutationsList
    * @param observer
    * @type {MutationCallback}
    */
    const onSlideActiveClassMutation = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                const observingClassNames = ['active'];
                if (mutation.target.classList.contains(observingClassNames)) {
                    toggleStateOfTabbableItemsInSlide(mutation.target, true);
                }
                else {
                    toggleStateOfTabbableItemsInSlide(mutation.target, false);
                }
            }
        }
    };
    /**
    * Set up the observer to watch for active class in slide
    */
    const observeForActiveClassMutations = () => {
        if (slideNodes && slideNodes.length > 0) {
            slideNodes.forEach((slideItem) => {
                const observer = new MutationObserver(onSlideActiveClassMutation);
                //Observe for class mutations
                observer.observe(slideItem, classMutationConfig);
            });
        }
    };
    observeForActiveClassMutations();
    /**
    * Callback function when a mutation happens.
    * We are looking for class mutation of active.
    * @param mutationsList
    * @param observer
    * @type {MutationCallback}
    */
    const onSlideButtonInActiveClassMutation = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                const observingClassNames = ['inactive'];
                if (mutation.target.classList.contains(observingClassNames)) {
                    mutation.target.tabIndex = '-1';
                }
                else {
                    mutation.target.tabIndex = '0';
                }
            }
        }
    };
    /**
    * Set up the observer to watch for active class in slide
    */
    const observeForSlideButtonInActiveClassMutations = () => {
        if (slideNavButtons && slideNavButtons.length > 0) {
            slideNavButtons.forEach((buttonItem) => {
                const observer = new MutationObserver(onSlideButtonInActiveClassMutation);
                //Observe for class mutations
                observer.observe(buttonItem, classMutationConfig);
            });
        }
    };
    observeForSlideButtonInActiveClassMutations();
});
// End of Accessibility
// -----------------------------------------------------------------------------------------------------
// FrontEnd
$(document).ready(function () {
    const desktopValues = {
        wrapperHeight: 400,
        sliderNavHeight: 80,
        topBottomPadding: 64,
        contentTopPadding: 32,
        lineHeightFix: 4,
        lineHeight: 24,
    };
    const tabletValues = {
        wrapperHeight: 256,
        sliderNavHeight: 48,
        topBottomPadding: 32,
        contentTopPadding: 8,
        lineHeightFix: 10,
        lineHeight: 24,
    };
    const mobileValues = {
        wrapperHeight: 300,
        sliderNavHeight: 48,
        topBottomPadding: 32,
        contentTopPadding: 8,
        lineHeightFix: 10,
        lineHeight: 24,
    };
    /**
    * All 3 resize functions do essentially the same.
    * Keeping it as 3 distinct ones for clarity and for future enhancements.
    */
    function resizeDescriptionHeightForDesktop() {
        const slides = document.querySelectorAll('.testimonial-slider .slide');
        Array.prototype.forEach.call(slides, (slide) => {
            let titleTag = slide.getElementsByClassName('testimonial-slider-title-desktop')[0];
            let titleTagHeight = titleTag.offsetHeight;
            const contentEl = slide.querySelector('.content-description');
            let wrapperProperties = desktopValues;
            const contentDescriptionHeight = wrapperProperties.wrapperHeight - (titleTagHeight + wrapperProperties.sliderNavHeight + wrapperProperties.topBottomPadding + wrapperProperties.contentTopPadding - wrapperProperties.lineHeightFix);
            contentEl.style.height = `${contentDescriptionHeight}px`;
            const noOfPossibleLines = Math.round((contentDescriptionHeight - wrapperProperties.contentTopPadding) / wrapperProperties.lineHeight);
            document.documentElement.style.setProperty('--testimonial-slider-lines', `${noOfPossibleLines}`);
        });
    }
    function resizeDescriptionHeightForTablet() {
        const slides = document.querySelectorAll('.testimonial-slider .slide');
        Array.prototype.forEach.call(slides, (slide) => {
            let titleTag = slide.getElementsByClassName('testimonial-slider-title-mobile')[0];
            let titleTagHeight = titleTag.offsetHeight;
            const contentEl = slide.querySelector('.content-description');
            let wrapperProperties = tabletValues;
            const contentDescriptionHeight = wrapperProperties.wrapperHeight - (titleTagHeight + wrapperProperties.sliderNavHeight + wrapperProperties.topBottomPadding + wrapperProperties.contentTopPadding + wrapperProperties.lineHeightFix);
            contentEl.style.height = `${contentDescriptionHeight}px`;
            const noOfPossibleLines = Math.round((contentDescriptionHeight - wrapperProperties.contentTopPadding) / wrapperProperties.lineHeight);
            document.documentElement.style.setProperty('--testimonial-slider-lines', `${noOfPossibleLines}`);
        });
    }
    function resizeDescriptionHeightForMobile() {
        const slides = document.querySelectorAll('.testimonial-slider .slide');
        Array.prototype.forEach.call(slides, (slide) => {
            let titleTag = slide.getElementsByClassName('testimonial-slider-title-mobile')[0];
            let titleTagHeight = titleTag.offsetHeight;
            const contentEl = slide.querySelector('.content-description');
            let wrapperProperties = mobileValues;
            const contentDescriptionHeight = wrapperProperties.wrapperHeight - (titleTagHeight + wrapperProperties.sliderNavHeight + wrapperProperties.topBottomPadding + wrapperProperties.contentTopPadding + wrapperProperties.lineHeightFix);
            contentEl.style.height = `${contentDescriptionHeight}px`;
            const noOfPossibleLines = Math.round((contentDescriptionHeight - wrapperProperties.contentTopPadding) / wrapperProperties.lineHeight);
            document.documentElement.style.setProperty('--testimonial-slider-lines', `${noOfPossibleLines}`);
        });
    }
    function resizeDescriptionHeight() {
        if (window.innerWidth >= 768 && window.innerWidth < 992) {
            resizeDescriptionHeightForTablet();
        }
        else if (window.innerWidth >= 992) {
            resizeDescriptionHeightForDesktop();
        }
        else {
            resizeDescriptionHeightForMobile();
        }
    }
    //Run on initial load
    resizeDescriptionHeight();
    //Run the resizeDescriptionHeight function on resize of the window
    window.addEventListener('resize', resizeDescriptionHeight);
});
